import { Box, Grid2, Typography } from '@mui/material';
import { useCallback } from 'react';
import { Controller, FieldErrors, useFormContext } from 'react-hook-form';

import { ProjectInputs } from 'src/global/types/project.type';

import { AdminInput } from '../AdminTextField';

interface SocialNetworksProps {
  isDisabled?: boolean;
}

export const SocialNetworks = ({ isDisabled }: SocialNetworksProps) => {
  const { control } = useFormContext<ProjectInputs>();
  const makeNodeElement = useCallback((iconUrl: string) => <img src={iconUrl} width={24} height={24} alt='icon' />, []);

  const socialFields = [
    {
      label: 'Enter Telegram URL',
      name: 'telegram',
      icon: makeNodeElement('/icons/socials/telegram.svg'),
    },
    {
      label: 'Enter X URL',
      name: 'x',
      icon: makeNodeElement('/icons/socials/x.svg'),
    },
    {
      label: 'Enter Discord URL',
      name: 'discord',
      icon: makeNodeElement('/icons/socials/discord.svg'),
    },
    {
      label: 'Enter YouTube URL',
      name: 'youtube',
      icon: makeNodeElement('/icons/socials/youtube.svg'),
    },
    {
      label: 'Enter Facebook URL',
      name: 'facebook',
      icon: makeNodeElement('/icons/socials/facebook.svg'),
    },
    {
      label: 'Enter Reddit URL',
      name: 'reddit',
      icon: makeNodeElement('/icons/socials/reddit.svg'),
    },
  ];

  return (
    <Box width={'100%'}>
      <Typography color='white' paddingBottom={1} fontSize={'16px'} variant='h6' lineHeight={'125%'} fontWeight={500}>
        Social Networks
      </Typography>
      <Grid2 paddingTop={3} container spacing={2}>
        {socialFields.map((field, index) => (
          <SocialField
            key={index}
            label={field.label}
            name={field.name}
            control={control}
            icon={field.icon}
            isDisabled={isDisabled}
          />
        ))}
      </Grid2>
    </Box>
  );
};

interface SocialFieldProps {
  label: string;
  name: string;
  control: any;
  isDisabled?: boolean;
  icon: React.ReactNode;
}

const SocialField: React.FC<SocialFieldProps> = ({ isDisabled, name, control, icon }) => {
  const { formState } = useFormContext<ProjectInputs>();
  const errors = formState.errors as FieldErrors<ProjectInputs>;

  const keyName = `info.network.${name}`;
  return (
    <Grid2 size={{ xs: 12, md: 6 }}>
      <Box>
        <Controller
          name={keyName}
          control={control}
          render={({ field }) => (
            <AdminInput
              startIcon={icon}
              readOnly={isDisabled}
              {...field}
              isError={!!(errors.info?.network as any)?.[name]}
              errorMsg={(errors.info?.network as any)?.[name]?.message}
              placeholder='Enter URL'
              fullWidth
            />
          )}
        />
      </Box>
    </Grid2>
  );
};
